import snakeCase from 'lodash/snakeCase'

export default {
  props: {
    inputId: {
      type: String,
      required: false,
      default: null
    },

    inputName: {
      type: String,
      required: false,
      default: null
    }
  },

  computed: {
    calculatedInputId() {
      if (this.inputId) {
        return this.inputId
      }

      return `${this.entityName}-${this.fieldName}`
    },

    calculatedInputName() {
      if (this.inputName) {
        return this.inputName
      }

      return `${this.entityName}[${snakeCase(this.fieldName)}]`
    }
  }
}
